// AUTO-GENERATED FILE - do not edit. Regenerated by scripts/generate-build-info.js.
export const BUILD_INFO = {
  gitSha: 'dbe55acf2dd4d4b9206a239bbd30eb71e2a1ef57',
  gitShaShort: 'dbe55acf',
  gitBranch: 'dev',
  gitTag: '',
  buildTime: '2026-11-04T06:00:22.716Z',
} as const;
